import {createBrowserRouter, Navigate, RouterProvider} from "react-router-dom";
import React, {lazy} from "react";
import checkAuth from "../app/auth";
import LogOut from "./LogOut";


const Root = lazy(() => import("./Root"));
const Main = lazy(() => import("./Main"));
const NotificationCenter = lazy(() => import("./NotificationCenter"));
const Login = lazy(() => import("./Login"));
const ChangePassword = lazy(() => import("./ChangePassword"));
const DetailList = lazy(() => import( "./DetailList"));
const Editor = lazy(() => import( "./Editor"));
const token = checkAuth()

// const route = (hasAuth : boolean) => {
const route = () => {
    const router = createBrowserRouter([
        {
            path: "*",
            element: <Navigate to={token ? "/detail-list" : "/login"} replace/>
        },
        {
            path: "/",
            element: <Root/>,
            // errorElement: <ErrorPage/>,
            children: [
                {
                    index: true,
                    element: <DetailList/>,
                },
                {
                    path: "/notifications",
                    element: <NotificationCenter/>,
                },
                {
                    path: "/permission",
                    element: <Main/>,
                },
            ],
        },
        {
            path: "/editor",
            // errorElement: <ErrorPage/>,
            element: <Editor/>,
        },
        {
            path: "/login",
            element: <Login/>,
        },
        {
            path: "/logOut",
            element: <LogOut/>
        },
        {
            path: "/change-password",
            element: <ChangePassword/>,
        },
    ]);

    return <RouterProvider router={router}/>;
};

export default route;
